import * as React from 'react';
import { FormControl, Select, MenuItem, Tooltip, SelectChangeEvent, InputLabel } from '@mui/material';
import styles from '../styles/SelectStyles';
import { withStyles } from '@mui/styles';

interface SelectProps {
    title?: string;
    classes: any;
    defaultValue?: any;
    disabled?: boolean;
    inputId?: string;
    optionsList?: string[];
    options?: object;
    placeholder?: string;
    value?: any;
    onChange?: (e: SelectChangeEvent<{ name?: string; value: any }>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    inputRef?: (ref: any) => void;
    selectLabel?: string;
    selectPlaceholder?: boolean;
}

const CustomSelect: React.FunctionComponent<SelectProps> = (props) => {
    const {
        classes,
        defaultValue,
        disabled,
        inputId,
        inputRef,
        onBlur,
        onChange,
        onFocus,
        options,
        optionsList,
        placeholder,
        value,
        title,
        selectLabel,
        selectPlaceholder,
    } = props;

    const PLACEHOLDER_TEXT = placeholder || 'Select';
    const placeholderItem = (
        <MenuItem key={0} value={''} classes={{ root: classes.listItem }} disabled={!selectPlaceholder}>
            {PLACEHOLDER_TEXT}
        </MenuItem>
    );
    const getDisplayValue = () => {
        if (value) {
            return value;
        }
        if (defaultValue) {
            return options ? Object.keys(options).find((k) => options[k] === defaultValue) : defaultValue;
        }
        return PLACEHOLDER_TEXT;
    };

    const renderValue = (val: any) => {
        if (val === '') {
            return PLACEHOLDER_TEXT;
        }
        return val;
    };
    const renderOptions = () => {
        if (options) {
            return Object.keys(options).map((key) => (
                <MenuItem key={key} value={key} classes={{ root: classes.listItem }}>
                    {options[key]}
                </MenuItem>
            ));
        }
        if (optionsList && optionsList.length) {
            return optionsList.map((option) => (
                <MenuItem key={option} value={option} classes={{ root: classes.listItem }}>
                    {option}
                </MenuItem>
            ));
        }
        return <div />;
    };

    return (
        <Tooltip title={title || ''}>
            <FormControl variant="standard" classes={{ root: classes.formControl }} disabled={disabled}>
                {selectLabel && <InputLabel id={selectLabel + 'selectLabel'}>{selectLabel}</InputLabel>}
                <Select
                    variant="standard"
                    value={getDisplayValue()}
                    renderValue={renderValue}
                    classes={{ select: classes.select, icon: classes.icon }}
                    MenuProps={{
                        classes: { paper: classes.dropDown },
                        anchorOrigin: { vertical: 'top', horizontal: 'left' },
                    }}
                    inputProps={{ id: inputId }}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    inputRef={inputRef}
                    labelId={selectLabel + 'selectLabel'}
                    displayEmpty={selectPlaceholder}
                >
                    {placeholderItem}
                    {renderOptions()}
                </Select>
            </FormControl>
        </Tooltip>
    );
};

export default withStyles(styles)(CustomSelect);
